import { Box, Flex, Grid, GridItem, Image, Text } from '@chakra-ui/react';
import React from 'react';
import Tooltips from './Tooltips';
import {
  ARREDONDAMENTO,
  ASPECTO_DESTAQUE,
  ASPECTO_QUADRADO,
  ESPACAMENTO,
} from './vitrines/constantes';

interface Props {
  data: any;
  phoneWidth?: number;
}

const Vazio: React.FC<{ aspectRatio: number; rotulo: string }> = ({
  aspectRatio,
  rotulo,
}) => (
  <Flex
    w="100%"
    sx={{ aspectRatio: String(aspectRatio) }}
    align="center"
    justify="center"
    borderWidth="3px"
    borderStyle="dashed"
    borderRadius="6px"
  >
    <Text color="gray.500" fontSize="xs" textAlign="center">
      {rotulo}
    </Text>
  </Flex>
);

const Bloco: React.FC<{
  item?: any;
  aspectRatio: number;
  rotulo: string;
  rounded: number;
}> = ({ item, aspectRatio, rotulo, rounded }) =>
  item?.file?.url ? (
    <Image
      w="100%"
      sx={{ aspectRatio: String(aspectRatio) }}
      objectFit="cover"
      borderRadius={`${rounded}px`}
      src={item.file.url}
      alt={item?.image_description || item?.name || ''}
    />
  ) : (
    <Vazio aspectRatio={aspectRatio} rotulo={rotulo} />
  );

const BannersGrid: React.FC<Props> = ({ data }) => {
  const itens = data?.items ?? [];
  const ehGrade = data?.type === 'grade_2x2';
  const gap = 4; // 16px na escala do preview

  return (
    <Box
      w="100%"
      position="relative"
      _hover={{ bg: 'gray.200' }}
      borderRadius="6px"
      transition="150ms ease"
      px={`${ESPACAMENTO}px`}
      py={`${ESPACAMENTO}px`}
    >
      {data?.name ? (
        <Flex align="center" mb={2}>
          <Text fontWeight="bold" fontSize="lg" mr={2}>
            {data.name}
          </Text>
          <Tooltips data={data} />
        </Flex>
      ) : (
        <Flex position="absolute" left={2} top={1} zIndex={1}>
          <Tooltips data={data} />
        </Flex>
      )}

      {ehGrade ? (
        <Grid templateColumns="repeat(2, 1fr)" gap={gap}>
          {[0, 1, 2, 3].map(i => (
            <GridItem key={i}>
              <Bloco
                item={itens[i]}
                aspectRatio={ASPECTO_QUADRADO}
                rotulo={`+ Quadrado ${i + 1}`}
                rounded={ARREDONDAMENTO}
              />
            </GridItem>
          ))}
        </Grid>
      ) : (
        <Flex direction="column" gap={gap}>
          <Bloco
            item={itens[0]}
            aspectRatio={ASPECTO_DESTAQUE}
            rotulo="+ Destaque"
            rounded={ARREDONDAMENTO}
          />
          <Grid templateColumns="repeat(3, 1fr)" gap={gap}>
            {[1, 2, 3].map(i => (
              <GridItem key={i}>
                <Bloco
                  item={itens[i]}
                  aspectRatio={ASPECTO_QUADRADO}
                  rotulo={`+ ${i}`}
                  rounded={ARREDONDAMENTO}
                />
              </GridItem>
            ))}
          </Grid>
        </Flex>
      )}
    </Box>
  );
};

export default BannersGrid;
